import { render, staticRenderFns } from "./LogoutPageAdsTab.vue?vue&type=template&id=4d961fea&scoped=true"
import script from "./LogoutPageAdsTab.vue?vue&type=script&lang=js"
export * from "./LogoutPageAdsTab.vue?vue&type=script&lang=js"
import style0 from "./LogoutPageAdsTab.vue?vue&type=style&index=0&id=4d961fea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d961fea",
  null
  
)

export default component.exports